<template>
  <footer class="sfdocs__footer">
    <p class="align-text-vertically domain">{{ domain }}</p>
    <p class="align-text-vertically credit">Made by Sunstreet IT</p>
  </footer>
</template>

<script>
import { mapMutations, mapState } from 'vuex';

export default {
  name: 'PageFooter',
  computed: {
      ...mapState(['currentDirectory', 'loggedIn']),
    domain() {
      return `${this.$route.params.recordType}/${
        this.$route.params.recordTypeSalesforceId
      }${this.currentDirectory}`;
    }
  }
};
</script>
